import React from 'react'
import {DatePicker} from 'antd'

export default function DateInput() {
  return <DatePicker />
}
